import apiConfig from "../config/api";

const apiTempUrl = `${apiConfig.apiUri}api/temp/user/request`;
const apiUserUrl = `${apiConfig.apiUri}api/user/request`;
const getToken = () => localStorage.getItem("AccessToken");

export const createSolicitudApi = (rut, companyRut, description, tipoRol = '', permisos = null) =>
  fetch(`${apiTempUrl}/create`, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
    },
    body: `RUT=${rut}&CompanyRut=${companyRut}&Description=${description}&Permits=${permisos ? JSON.stringify(permisos) : ''}&RoleType=${tipoRol}`,
  });

export const createSolicitudADApi = (rut, companyRut, description = '', tipoRol = '', permisos = null) =>
  fetch(`${apiUserUrl}/create`, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
          // '14ff4a9f0d8f46f58010f8d91bd58b23',
      Authorization: `Bearer ${getToken()}`,
    },
    body: `RUT=${rut}&CompanyRut=${companyRut}&Description=${description}&Permits=${permisos ? JSON.stringify(permisos) : ''}&RoleType=${tipoRol}`,
  });

export const deleteSolicitudADApi = (rut, idSolicitud) =>
  fetch(`${apiUserUrl}/${rut}/${idSolicitud}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      Authorization: `Bearer ${getToken()}`,
    }
  });

export const getSolicitudesApi = (rut) =>
  fetch(`${apiTempUrl}/${rut}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
    }
  });

export const deleteSolicitudApi = (rut, idSolicitud) =>
  fetch(`${apiTempUrl}/${rut}/${idSolicitud}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
    }
  });

export const sendAdRemainderApi = (id) =>
  fetch(`${apiUserUrl}/sendreminder/${id}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
    },
  });

export const sendReminderApi = (idSolicitud) =>
  fetch(`${apiTempUrl}/sendreminder`, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
    },
    body: `IDRequest=${idSolicitud}`,
  });
